import ExpertProfileEditPortfolioItemModule from './expert-profile-edit-portfolio-item.module'

export default ExpertProfileEditPortfolioItemModule
